import { render, staticRenderFns } from "./ReceviceEcoupon.vue?vue&type=template&id=5edd1e04&"
import script from "./ReceviceEcoupon.vue?vue&type=script&lang=js&"
export * from "./ReceviceEcoupon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports